import $ from 'jquery';

import { i18n } from '../../translation.js';
import FileUploadMultiple from '../file-upload-multiple/file-upload-multiple.js';

import template from './course-subject-group-signup.vhtml';
import { trackFormSubmit } from '../../scripts/tag-manager';

export default {
	validate: null,
	template,
	components: {
		FileUploadMultiple,
	},
	props: {
		qdPopup: {
			type: Object,
			default: null,
		},
		termsConditions: {
			type: String,
			default: '',
		},
	},
	computed: {
		showOmstillingsfondLink() {
			return this.language === 'da';
		},
		isFormValid() {
			return Object.keys( this.fields ).reduce( ( valid, key ) => this.fields[key].valid && valid, true );
		},
		headline() {
			switch ( this.submitStatus ) {
			case 'success':
				return i18n.t( 'youSignupForSuccess' );
				break;
			case 'error': 
				return i18n.t( 'youSignupForError' );
				break;
			default:
				return i18n.t( 'youSignupFor' );
			}
		},
		submitMessage() {
			switch ( this.submitStatus ) {
			case 'success':
				return i18n.t( 'confirmationEmailSent' );
				break;
			case 'error': 
				return '';
				break;
			default:
				return '';
			}
		},
		groupDates() {
			return this.qdPopup.data.courseDates ? this.qdPopup.data.courseDates : null;
		},
	},
	data() {
		return {
			payer: 'P',
			commentary: false,
			popupData: null,
			isSubmitting: false,
			submitStatus: '',
			language: window.siteData.language,
			referralType: '',
		};
	},
	watch: {
		qdPopup() {	
			this.popupData = this.qdPopup !== null ? this.qdPopup.data : null;
			this.commentary = false;
			this.submitStatus = '';
		},
	},
	methods: {
		addCommentary() {
			this.commentary = true;
		},
		validateBeforeSubmit( event ) {
			this.$validator.validateAll().then( () => {
				this.submit( event.target );
			});
		},
		submit( el ) {
			this.isSubmitting = true;
			submitForm( el )
			.then( () => {
				this.submitStatus = 'success';

				// TagManager
				trackFormSubmit( 'CourseGroupSignup' );
			})
			.catch( () => {
				this.submitStatus = 'error';
			})
			.always( () => this.isSubmitting = false );
		},
	},
	created() {
		this.$options.referralTypes = [
			{ value: '', text: this.$t( 'referral.choose' ) },
			{ value: 'FAK', text: this.$t( 'referral.fak' ) },
			{ value: 'ADVERTISING', text: this.$t( 'referral.advertising' ) },
			{ value: 'CONFERENCE', text: this.$t( 'referral.atConference' ) },
			{ value: 'OTHER', text: this.$t( 'referral.other' ) },
		];
	},
};

/**
 * Posts form to API
 */
function submitForm( el ) {

	const formData = new FormData( el );

	return $.ajax({
		url: '/wp-json/qd/forms/v1/easv_group_signup',
		type: 'POST',
		data: formData,
		cache: false,
		contentType: false,
		processData: false,
	});
}



// WEBPACK FOOTER //
// ./assets/_js/components/course-subject-group-signup/course-subject-group-signup.js